var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTvIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_510_8444",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_510_8444",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAABmJLR0QA/wD/AP+gvaeTAAACfklEQVR4nO3cMWsUQRiH8XdUVEQbEbRIoyAI2thpY62Q1tbOtBH9Apa2QRBs/QrXKBF7SWEjCAraJGBjUBRFD30szsV1NsZcbs/33Zn/r0xxeWceluzeTc5MRERERERERERERIYvAXgPIb/t8R5A/qQgwShIMPvyH6SUkscgtcr/husKCUZBglGQYBQkGAUJRkGCUZBgFCQYBQlGQYJRkGAUJBgFCUZBggkfBLgBPAIWvWf5L8h4z5MDvrTGewic8Z6pT539H0CQ3Bi4Dxzznq0PJQRpvAOWgb3eM86ipCCNZ8Al7zl3q8QgjRFw0nveaZUcBOAzcAc47D33TpUepLEOXAPCn6CpJUjjKXDBew3bqS0IwHfgAXDcey1bqTFI4yNwGzjgvaa2moM0XhLobZh8uPDvZc3BaTMbAavAWe9hcp3/D4l2tnfOV+03M1tMKa3O8XdsK19fjVdI234zO+89RFvn9HtFxmZ2z8xWvAdpqzXIEzNbTik99x6ko7K7rFfAVe81tXX2v5Ign5g8gxz0Xk+utiA/mDyln/Bex9/UFGQNuOg9/7/UEGQDWGIgD70lB/kKrABHvGeeRqlBRsAp71l3o7QgL4DL3jPOopQgm0xOnAz+wXboQcbAXeCo91x9GWKQtV+jPQbOec/TtyEGOcQAj/fsVL7/4T8PKV2+/4N4eKqJggSjIMEoSDAKEoyCBKMgwShIMAoSjIIEoyDB6Lvfg9EVEoyCBKMgIiIisjXgFvAh//C+QK+BK33vX68HGpgc+183s0F/ZdIUNlJKC32+4Dxue3UrPYNeNy+l9NbMbprZ+z5fN6g3ZnbdewgRERERERERERERiegn0PGGN9ZlDdEAAAAASUVORK5CYII="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTvIcon);
export default __webpack_public_path__ + "static/media/TvIcon.1a269c1e39ed714394b9afd6f9269737.svg";
export { ForwardRef as ReactComponent };